import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, } from '@angular/core';
import { ExamsService } from '@shared/views/exams/exams.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { AuthService } from '@app/auth/auth.service';
import { Subscription } from 'rxjs';
import { ExamsFilterService } from '@shared/components/exams-filter/exams-filter.service';
import { DataView } from 'primeng/dataview';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { DatabaseService } from '../../../../database/database.service';


@Component({
  selector: 'app-list-cargados',
  templateUrl: './list-cargados.component.html',
  styleUrls: ['./list-cargados.component.scss']
})
export class ListCargadosComponent implements OnInit, OnDestroy {
  @Input() listExams: any[] = [];
  @Input() motivosCierre: any[];
  @Input() tipo: string;
  @Output() emitCloseExam: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dv', { static: false }) dataview: DataView;

  // ! Esto no se si lo necesito o no
  display: boolean;
  prestador: string;
  confPage: ConfPage = new ConfPage();

  filterBy = 'examenGroup';
  subscriptionClearFilter: Subscription;
  subscription: Subscription;
  filterCountCargado: number = 0;
  sinRegistroFilter: boolean;
  inputSearch: string;
  isOnline = true;


  constructor(
    private examsFilterService: ExamsFilterService,
    private authService: AuthService,
    private connectionService: ConnectionService,
    private databaseService: DatabaseService) {
      this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
  }

  ngOnInit(): void {
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    });
    this.authService.currentUser.subscribe(
      (user) => (this.prestador = user.modelName)
    );
    this.subscriptionFilter();
    const filtro = this.examsFilterService.getLocalAdvancedFilter(this.tipo);
    this.setCount(this.tipo, filtro);
    this.setFilter();
    this.getConfigPage();
  }

  ngOnDestroy(): void {
    this.unsubcriptionFilter();
  }

  getConfigPage() {
    const type = 'configPage' + this.tipo;
    const configPage = localStorage.getItem(type);
    this.confPage = configPage ? JSON.parse(configPage) : new ConfPage();
  }

  unsubcriptionFilter() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionClearFilter) {
      this.subscriptionClearFilter.unsubscribe();
    }
    if (this.listExams.length === 0) {
      this.sinRegistroFilter = true;
    }
  }

  subscriptionFilter(): void {
    this.subscription = this.examsFilterService.filterExams$.subscribe((res) => {
      this.setCount(res.tipo, res.data);
      this.sinRegistroFilter = false;
      setTimeout(() => {
        this.actionFilterAdvanced(res.tipo);
      }, 100);
    }
    );
    this.subscriptionClearFilter = this.examsFilterService.clearFilterExams$.subscribe(
      (res) => {
        this.clearCount(res);
      }
    );
  }

  setCount(tipo, data): void {
    if (!data) {
      return;
    }
    if (this.dataview) {
      this.dataview.paginate({ first: 0, rows: this.dataview.rows });
    }
    switch (tipo) {
      case 'cargados':
        this.filterCountCargado = this.examsFilterService.countFilter(data);
        break;
    }
  }

  /**
   * Método que se encarga de actualizar la lista y emitir evento para actualizar listas del padre (competente de tabs)
   * @param examen
   * @param examenPorEnviar
   */
  updateList(examen, examenPorEnviar?): void {
    const tempList = [...this.listExams];
    this.listExams = [];
    if (examenPorEnviar) {
      tempList.splice(tempList.indexOf(examen), 1);
      setTimeout(() => {
        this.listExams = tempList;
        this.emitEvent(examen, examenPorEnviar);
      }, 1);
    } else {
      tempList.splice(tempList.indexOf(examen), 1);
      setTimeout(() => {
        this.listExams = tempList;
        this.emitEvent(examen, null);
      }, 1);
    }
  }

  /**
   * Método que se encarga de armar el objeto y emitirlo
   * @param examen
   * @param porEnviar
   */
  emitEvent(examen, porEnviar?): void {
    const objSalida = {} as any;
    objSalida.examen = examen;
    objSalida.examenPorEnviar = porEnviar;
    this.emitCloseExam.emit(objSalida);
  }

  clearCount(tipo): void {
    this.sinRegistroFilter = true;
    switch (tipo) {
      case 'cargados':
        this.filterCountCargado = null;
        this.dataview.filter('');
        break;
    }
  }

  filtros(): void {

    if (this.tipo === 'cargados' && this.isOnline === false) {
      console.log('no aplican filtros para cargados en offline');
    } else {
      this.examsFilterService.openSidebarFilter(this.tipo);
    }
  }

  limpiarFiltro(): void {
    if (this.isOnline) {
      this.clearCount(this.tipo);
      this.examsFilterService.cleanFilter(this.tipo);
      if (this.tipo === 'cargados') {
        this.databaseService.cleanTable('examenesCargados');
      }
    }
  }

  setFilter(): void {
    setTimeout(() => {
      switch (this.tipo) {
        case 'cargados':
          this.filterBy = 'numeroCarpeta,id,provinciaNombreEstudio,lote.id,trabajador.apellidoNombre,trabajador.tipoDocumento,trabajador.numeroDocumento,' +
          'esops.0.descripcion,fechaAsignacion,fechaCarga,lote.empresa.razonSocial,lote.empresa.cuit,lote.numeroContrato,lote.numeroLote,enviado,examenGroup' +
          'examenData.id,examenData.provinciaNombreEstudio,examenData.lote.id,examenData.trabajador.apellidoNombre,examenData.trabajador.tipoDocumento,examenData.trabajador.numeroDocumento,' +
          'examenData.esops.0.descripcion,examenData.fechaAsignacion,examenData.fechaCarga,examenData.lote.empresa.razonSocial,examenData.lote.empresa.cuit,examenData.lote.numeroContrato,examenData.lote.numeroLote,examenData.enviado,examenData.examenGroup';
          break;
        default:
          this.filterBy = 'provinciaNombreEstudio,';
          break;
      }
    }, 10);
  }

  actionFilter(event): void {
    if (event.target.value === undefined || event.target.value === null) {
      this.sinRegistroFilter = false;
      return;
    }
    if (event.target.value === '') {
      this.sinRegistroFilter = false;
    }
    this.dataview.filter(event.target.value);
    setTimeout(() => {
      if (event.target.value) {
        this.sinRegistroFilter =
          this.dataview.filteredValue &&
          this.dataview.filteredValue.length <= 0;
      }
    }, 100);
  }

  actionFilterAdvanced(tipo): void {
    switch (tipo) {
      case 'cargados':
        if (this.listExams.length > 0) {
          this.sinRegistroFilter = false;
          if (this.dataview.filterValue) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter =
              this.dataview.filteredValue &&
              this.dataview.filteredValue.length <= 0;
          }
        } else {
          if (this.dataview) {
            this.dataview.filter(this.dataview.filterValue);
            this.sinRegistroFilter = true;
          }
        }
        break;
    }
  }

  showDataView(): boolean {
    switch (this.tipo) {
      case 'cargados':
        return (
          this.listExams.length > 0 ||
          (this.listExams.length <= 0 && this.filterCountCargado > 0)
        );
    }
  }

  onPage(event, tipo) {
    this.confPage = event;
    const type = 'configPage' + this.tipo;
    localStorage.setItem(type, JSON.stringify(this.confPage));
  }
}

export class ConfPage {
  first: number;
  rows: number;

  constructor() {
    this.first = 0;
    this.rows = 5;
  }
}
